import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useUpsell } from './UpsellContext';
export function BuyBar() {
  const {
    openUpsell
  } = useUpsell();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-43">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-rose-light/40 shadow-[0_-8px_30px_-10px_rgba(212,154,142,0.3)]" data-id="element-44">
          <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between gap-3" data-id="element-45">
            {/* Price on the left */}
            <div className="flex flex-col leading-tight" data-id="element-46">
              <span className="text-xs text-dark/50 line-through decoration-rose-deep/40" data-id="element-47">
                $173.930
              </span>
              <span className="text-xl sm:text-2xl font-bold text-rose-deep" data-id="element-48">
                $19.990{' '}
                <span className="text-xs font-normal text-dark/50" data-id="element-49">ARS</span>
              </span>
            </div>

            {/* CTA on the right */}
            <motion.button type="button" onClick={openUpsell} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="flex-1 max-w-[260px] bg-rose-deep text-white font-semibold py-3 px-4 rounded-full shadow-premium hover:bg-rose-deep/90 transition-colors text-[13px] sm:text-base tracking-wide" data-id="element-50">
              QUIERO ACCEDER AHORA
            </motion.button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}